import { cn } from '../lib/utils';
import { motion } from 'framer-motion';

const StatsCard = ({ label, value, icon: Icon, trend, className }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={cn(
        "stats-card",
        className
      )}
      data-testid={`stats-card-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-widest text-muted-foreground font-medium">
          {label}
        </span>
        {Icon && <Icon className="w-4 h-4 text-muted-foreground" />}
      </div>
      <div className="text-4xl font-bold text-foreground font-mono">
        {value}
      </div>
      {trend && (
        <div className={cn(
          "text-sm mt-1",
          trend.positive ? "text-emerald-500" : "text-muted-foreground"
        )}>
          {trend.text}
        </div>
      )}
    </motion.div>
  );
};

export default StatsCard;
